<!--
  https://xd.adobe.com/view/326dbe43-01dd-4c10-a644-535309242a5c-673e/
  https://docs.google.com/presentation/d/1fQuFcQgTCeefoe3achyrZWpSc6S5g2a7a3d8lpET6KY/edit#slide=id.p
-->
<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 mb2">
      <!-- mobile setup -->
      <div class="clearfix gibson mb2" v-if="showMobile">
        <div class="col-12 px2">
          <div class="clearfix border muted-border p2 py3 shadow md-hide lg-hide">
            <div class="col-12 px2">
              <p class="h4 semi-bold line-height-2 my2">Opgavetyper</p>
              <p class="h5 regular darkblue line-height-golden mb3">Her kan du vælge de opgavetyper, som du beskæftiger dig med. Når du klikker på en kategori, kan du fjerne eller tilføje opgavetyper. Til højre under "valgte opgavetyper", kan du prioritere i de valgte opgaver. Det vil sige at du kan vælge de opgavetyper, som du helst vil beskæftige dig med i forhold til andre. Du prioriterer i opgavetyperne ved at trække i den opgavetype, som du ønsker at flytte op eller ned. Den øverste opgavetype er din 1. prioritet.</p>
            </div>
            <div class="mb3 flex flex-column">
            <div class="flex flex-wrap gap-10 col-12 mb3 p0">
              <div class="col-12 p0"><p class="h4 semi-bold line-height-2 p0 mt2 mb1 gibson darkblue">Vælg Region</p></div>
              <div class="lightgrey-background p1 px1 flex items-center" style="width:300px;" v-for="(region,index) in regions" :key="index">
                <!-- <span class="h6 regular ml1 line-height-1 m0 p0">{{region.text}}</span>
                <input style="height:18px;width:18px;" type="checkbox" :id="'selectregion' + region.value" :value="region.value" @change="updateregion(region)" unchecked-value="not_accepted" class="ml-auto" /> -->
                <el-checkbox-group v-model="selectedregion">
                  <el-checkbox style="height:18px;width:18px;" :label="region.ID" :disabled="partnerregion.trim() === region.NAME.replace('Region ', '').trim()" :key="region.ID" :id="'selectregion' + region.ID" @change="updateregion()" class="">
                    {{region.NAME.replace('Region ', '')}}
                  </el-checkbox> 
                </el-checkbox-group>
              </div>
            </div>
            <!-- https://docs.google.com/document/d/1FdsTwi6R7G__OU7-E_hb_kLJYrneiy3krFoIG0xVHHw/edit# -->
            <!-- https://docs.google.com/presentation/d/1IgmkuD-0QuasT_43HKbQFON-MgvAwPgixv6SrF2XrAo/edit#slide=id.g1278538f2d0_0_61 -->
            <p class="col-12 h5 semi-bold line-height-2 px2 darkblue">Vælg hvilke entreprisetyper du laver ?</p>
            <div class="col-12 flex flex-column justify-start items-start p0">
              <div id="enterprise" style="width:300px;" class="mt1 mr1 flex lightgrey-background p1" v-for="item in enterpriseoption" :key="'selectedent' + item.value">
                  <span class="h6 semi-bold ml1 line-height-1 m0 p0">{{item.text}}</span>
                  <input type="checkbox" :id="'selectedent' + item.value" :value="item.value" @change="updateenterprise(item)" unchecked-value="not_accepted" class="ml-auto" />
              </div>
            </div>
            <el-alert v-if="noenterprise" title="Vælg venligst din virksomhed" type="error" effect="light" show-icon :closable="false" class="line-height-1 mt2 col-12 mx-auto"></el-alert>
            </div>
            <dineopgavetyper :enterpriseid="enterpriseid" :ispartnerGuarantee="ispartnerGuarantee"  @noenterprise="showerror($event)"></dineopgavetyper>
          </div>
          <div class="clearfix p2 xs-hide sm-hide">
            <div class="col-10 px2 gibson darkblue">
              <p class="h4 semi-bold line-height-2 my2">Opgavetyper</p>
              <p class="h6 regular darkblue line-height-golden mb3">Her kan du vælge de opgavetyper, som du beskæftiger dig med. Når du klikker på en kategori, kan du fjerne eller tilføje opgavetyper. Til højre under "valgte opgavetyper", kan du prioritere i de valgte opgaver. Det vil sige at du kan vælge de opgavetyper, som du helst vil beskæftige dig med i forhold til andre. Du prioriterer i opgavetyperne ved at trække i den opgavetype, som du ønsker at flytte op eller ned. Den øverste opgavetype er din 1. prioritet.</p>
            </div>
            <dineopgavetyper :enterpriseid="enterpriseid" :ispartnerGuarantee="ispartnerGuarantee" @noenterprise="showerror($event)"></dineopgavetyper>
          </div>
        </div>
      </div>
      <!-- desktop setup -->
      <div class="clearfix ml4" v-if="!showMobile">
          <div class="col-7 p2 py3 mb2">
            <div class="clearfix px2">
              <p class="h4 semi-bold line-height-2 mt2 mb1 gibson darkblue">Opgavetyper</p>
              <p class="h5 gibson line-height-golden darkblue regular">Her kan du vælge de opgavetyper, som du beskæftiger dig med. Når du klikker på en kategori, kan du fjerne eller tilføje opgavetyper. Til højre under "valgte opgavetyper", kan du prioritere i de valgte opgaver. Det vil sige at du kan vælge de opgavetyper, som du helst vil beskæftige dig med i forhold til andre. Du prioriterer i opgavetyperne ved at trække i den opgavetype, som du ønsker at flytte op eller ned. Den øverste opgavetype er din 1. prioritet.</p>
            </div>
          </div>
          <div class="clearfix" v-if="loading">
            <div class="loader"></div>
          </div>
          <div class="flex flex-wrap gap-10 col-7 mb3" v-else>
            <div class="col-12"><p class="h4 semi-bold line-height-2 p0 mt2 mb1 gibson darkblue">Vælg Region</p></div>
            <div class="lightgrey-background p1 px1 flex items-center" style="width:300px;" v-for="(region,index) in regions" :key="index">
              <!-- <span class="h6 regular ml1 line-height-1 m0 p0">{{region.NAME.replace('Region ', '')}}</span>
              <input style="height:18px;width:18px;" type="checkbox" :id="'selectregion' + region.ID" :value="region.ID" @change="updateregion(region)" unchecked-value="not_accepted" class="ml-auto" /> -->
              <el-checkbox-group v-model="selectedregion">
                <el-checkbox style="height:18px;width:18px;" :label="region.ID" :disabled="partnerregion.trim() === region.NAME.replace('Region ', '').trim()" :key="region.ID" :id="'selectregion' + region.ID" @change="updateregion()" class="">
                  {{region.NAME.replace('Region ', '')}}
                </el-checkbox> 
              </el-checkbox-group>
            </div>
          </div>
          <div class="mb3 flex flex-column mb3">
            <!-- https://docs.google.com/document/d/1FdsTwi6R7G__OU7-E_hb_kLJYrneiy3krFoIG0xVHHw/edit# -->
            <p class="col-7 h4 semi-bold line-height-2 p0 darkblue px2">Vælg hvilke entreprisetyper du laver ?</p>
            <div class="col-7 flex justify-start items-center gap-10">
              <div id="enterprise" style="width:300px;"  class="p1 lightgrey-background p1 px1 flex items-center" v-for="item in enterpriseoption" :key="'selectedent' + item.value">
                  <span class="h6 ml1 line-height-1 m0 p0">{{item.text}}</span>
                  <input style="height:18px;width:18px;" type="checkbox" :id="'selectedent' + item.value" :value="item.value" @change="updateenterprise(item.value)" unchecked-value="not_accepted" class="ml-auto" />
              </div>
            </div>
            <el-alert v-if="noenterprise" title="Vælg venligst din virksomhed" type="error" effect="light" show-icon :closable="false" class="line-height-1 mt2 col-12 mx-auto"></el-alert>
          </div>
        <div class="clearfix mb4 px2">
          <dineopgavetyper :enterpriseid="enterpriseid" :ispartnerGuarantee="ispartnerGuarantee" @noenterprise="showerror($event)" ></dineopgavetyper>
        </div>
      </div>
      <div class="py2"></div>
    </div>
    <b-modal  centered hide-footer hide-header id="confirmGarantee" :no-close-on-backdrop="true" size="md" v-model="confirmGarantee" ref="confirmGarantee" no-close-on-esc>
      <div class="col-12 flex justify-end items-center white-background ">
            <button type="button" @click="closeconfirmGarantee()" class="white-button no-border not-rounded gibson ">
              <span>
              <i class="el-icon-close"></i>
              </span>
            </button>
          </div>
      <div class="clearfix white-background px2 ">
        <div class="flex flex-column col-12 p0">
          <p class="my2 darkblue mx-auto">
          <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#19A3C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </p>
          <p class="bold h3 darkblue pt1 mx-auto" >Tak for besøget</p>
            <p class="h6 darkblue py1 mt2 mx-auto" >Hvis du ændrer din job definition, vil du miste garantien fra os. Er du sikker på, at du ønsker at fortsætte?</p>
        </div>
      </div>
      <div class="flex justify-around my2">
      <button type="button" class="center p2 px3 outlined-button" @click="closeconfirmGarantee()"><span class="h6 regular">Afbestille</span></button>
      <button type="button" class="center p2 px3 action-button" @click="confirmgarante()"><span class="h6 regular">Blive ved</span></button>
      </div>
    </b-modal>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import dineopgavetyper from './DineOpgavetyper'
import Simplert from 'vue2-simplert'
import Imentor from './imentor'
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'opgavetyper',
  components: {
    Imentor,
    dineopgavetyper,
    Simplert,
    ErrorHandler
  },
  data () {
    return {
      enterpriseid: 2,
      enterpriseoption: [
        { value: 1, text: 'Hovedentreprise' },
        { value: 2, text: 'Fagentreprise' }
      ],
      haaid: '',
      noenterprise: false,
      packagehandle: '',
      garantiHandle: true,
      confirmGarantee: false,
      regions: [],
      salesPersonbitrix: '',
      partnerregion: '',
      selectedregion: [],
      partnerregions: [],
      loading: false,
      ispartnerGuarantee: 0
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.partnerregion = localStorage.getItem('prisenRegion')
    this.haaid = localStorage.getItem('haaid')
    this.getAllRegion()
    this.getAllRegionbypartnerID()
    this.getguaranteeStatus()
    this.getenterprise()
  },
  methods: {
    showerror (bool) {
      this.noenterprise = bool
    },
    showpopupConfirmgarantee () {
      this.confirmGarantee = true
    },
    confirmgarante () {
      if (this.regions.length > 0) {
        this.updatePartnerregion()
      } else {
        this.addregion()
      }
    },
    closeconfirmGarantee () {
      this.loading = true
      this.regions = []
      this.confirmGarantee = false
      this.getAllRegion()
    },
    getenterprise () {
      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.enterpriseid = Number(res.data.UF_CRM_COMPANY_ENTERPRISE)
            if (this.enterpriseid === 0 || this.enterpriseid === null) {
              document.getElementById('selectedent2').checked = true
              this.updateenterprise(2, 'noshow')
            } else {
              this.updatebutton(this.enterpriseid)
            }
            this.getpackagehandle()
          }
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    getguaranteeStatus () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      this.$http.get(this.$bitrixapi + 'partner/guaranteeDistance', {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.ispartnerGuarantee = res.data.guarantee
          }
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    getAllRegion () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/regions/all', { headers }, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.regions = res.data
            this.regions.forEach(l => {
              if (this.partnerregion.trim() === l.NAME.replace('Region ', '').trim()) {
                if (!this.selectedregion.includes(l.ID)) {
                  this.selectedregion.push(l.ID)
                }
              }
            })
          }
          this.loading = false
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    getAllRegionbypartnerID () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/regions', { headers }, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.partnerregions = res.data
            this.partnerregions.forEach(l => {
              if (!this.selectedregion.includes(l.REGION_ID)) {
                this.selectedregion.push(l.REGION_ID)
              }
            })
          }
        },
        (response) => {
          var error = response.body.message
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    getpackagehandle () {
      this.packagehandle = localStorage.getItem('PartnerPackageHandle')
      this.getbitrixinfo()
    },
    getbitrixinfo () {
      this.$http.get(this.$bitrixapi + 'bitrix/getPackage/' + this.haaid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            localStorage.setItem('PartnerPackageHandle', res.data.PACKAGE_HANDLE)
            this.packagehandle = res.data.PACKAGE_HANDLE
          }
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    addregion () {
      this.loading = true
      this.closeconfirmGarantee()
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        regionIds: this.selectedregion
      }
      this.$http.post(this.$bitrixapi + 'partner/region/add', data, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.loading = false
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          }
        },
        (response) => {
          this.loading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    updatebutton (item = 2) {
      if (item === 3) {
        document.getElementById('selectedent2').checked = true
        document.getElementById('selectedent1').checked = true
      } else {
        var selectedEnt = document.getElementById('selectedent' + item)
        selectedEnt.checked = true
      }
    },
    updatePartnerregion () {
      this.loading = true
      this.closeconfirmGarantee()
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        regionIds: this.selectedregion
      }
      this.$http.post(this.$bitrixapi + 'partner/region/edit', data, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.loading = false
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          }
        },
        (response) => {
          this.loading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    updateenterprise (item = 2, noshow = '') {
      if (this.packagehandle === 'vaekstopgavegaranti' || this.packagehandle === 'vaekstgaranti') {
        if (document.getElementById('selectedent2').checked) {
          document.getElementById('selectedent2').checked = true
        } else {
          document.getElementById('selectedent2').checked = true
          return
        }
      }
      if (document.getElementById('selectedent2').checked && document.getElementById('selectedent1').checked) {
        this.enterpriseid = 3
      } else if (document.getElementById('selectedent2').checked && !document.getElementById('selectedent1').checked) {
        this.enterpriseid = 2
      } else if (document.getElementById('selectedent1').checked && !document.getElementById('selectedent2').checked) {
        this.enterpriseid = 1
      } else {
        document.getElementById('selectedent' + item).checked = true
        return false
      }
      if (this.enterpriseid === '' || this.enterpriseid === null) {
        return false
      }
      var data = {
        UF_CRM_COMPANY_ENTERPRISE: this.enterpriseid
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplierCustomFields/' + this.haaid, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.noenterprise = false
            if (noshow !== 'noshow') {
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            }
            this.updatebutton(this.enterpriseid)
          }
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    updateregion () {
      if (this.ispartnerGuarantee === 1) {
        this.showpopupConfirmgarantee()
      } else {
        this.confirmgarante()
      }
    }
  }
}
</script>
<style scoped>
.fa-check-circle {
  font-size: 26px;
}
.gap-10 {
  gap: 10px;
}
.modal-header,
.modal-footer {
  border-top: 0;
  border-bottom: 0;
}
#enterprise input:disabled {
      color: #5897fb;
}
#enterprise .custom-control-input {
    position: inherit;
    z-index: 1;
    opacity: 1;
}
#enterprise .custom-control {
  padding-left: 0;
  margin-right: 8px;
}
#enterprise .alt-checkmark {
    position: absolute;
    right: -22px;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    transition: all .2s linear;
    padding: 4px;
    top: -10px;
}
#enterprise .container input {
    position: absolute;
    opacity: 1;
    cursor: pointer;
    height: 20px;
    width: 20px;
    z-index: 5;
    top: 25%;
}
#enterprise .container input.selected+div+.alt-checkmark {
    background: #4dcf55!important;
    border-color: #4dcf55!important;
    border: 1px solid #4dcf55!important;
    display: flex!important;
    justify-content: center;
    z-index: 2;
    top: -10px;
    right: -5px;

}
#enterprise .container input.selected+div+.alt-checkmark:after {
        display: block;
    }
#enterprise .alt-checkmark:after{
        content: "";
    }
#enterprise .container .alt-checkmark:after {
    left: 8px!important;
    top: 4px!important;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    transform: rotate(38deg);
}
</style>



// WEBPACK FOOTER //
// Opgavetyper.vue?575228f7